export const localesKo = {
  "lnb.sideBar.body.main.link": "대시보드",
  "lnb.sideBar.body.smartthings.link": "SmartThings Pro",
  "lnb.sideBar.body.facilities.link": "건물/장치",
  "lnb.sideBar.body.plans.link": "상품/요금",
  "lnb.sideBar.body.contracts.link": "계약/정산",
  "lnb.sideBar.body.people.link": "이용/방문",
  "lnb.sideBar.body.operations.link": "관리/협업",
  "lnb.sideBar.body.info.link": "안내/설정",
  "lnb.sideBar.body.accessBooking.link": "출입/예약",
  "lnb.sideBar.body.accessRecord.link": "출입기록 조회",

  "lnb.sideBar.body.monitoring.link": "공간 모니터링",
  "lnb.sideBar.body.building.link": "건물",
  "lnb.sideBar.body.product.link": "상품",
  "lnb.sideBar.body.workorder.link": "워크오더",
  "lnb.sideBar.body.cs.link": "VoC/고객문의",
  "lnb.sideBar.body.contract.link": "신청/계약",
  "lnb.sideBar.body.contract-s2.link": "공간예약 신청",
  "lnb.sideBar.body.contractGroup.link": "계약그룹",
  "lnb.sideBar.body.provider.link": "정산정보",
  "lnb.sideBar.body.reservation.link": "공용공간 예약",
  "lnb.sideBar.body.commonSpaceSettlement.link": "공용공간 정산",
  "lnb.sideBar.body.user.link": "이용자",
  "lnb.sideBar.body.visitor.link": "방문자",
  "lnb.sideBar.body.notice.link": "공지사항",
  "lnb.sideBar.body.org.link": "계약자",
  "lnb.sideBar.body.billing.link": "빌링 스케줄",
  "lnb.sideBar.body.billing-s2.link": "공간예약 결제",
  "lnb.sideBar.body.option.link": "설정",
  "lnb.sideBar.body.guide.link": "이용안내",
  "lnb.sideBar.body.voc.link": "VoC 항목설정",
  "lnb.sideBar.body.customLink.link": "외부 링크 연결",
  "lnb.sideBar.body.userAdditionalInfo.link": "이용자 부가정보",
  "lnb.sideBar.body.price.link": "공용공간 요금",
  "lnb.sideBar.body.cctv.link": "CCTV 장치",
  "lnb.sideBar.body.login": "최근접속",
  "lnb.sideBar.body.accessDevice.link": "출입장치",
  "lnb.sideBar.body.accessControl.link": "출입권한",
  "lnb.sideBar.body.reservationConfig.link": "예약정보",
  "lnb.sideBar.body.setting.link": "STPM 설정",
  "lnb.sideBar.body.help.link": "서비스 가이드",
  "lnb.sideBar.body.iotConfig.link": "IoT 관리",

  // 공간 예약 현황
  "reservation.list.body.button.text": "일별 예약현황 보기",
  "reservation.display.body.title": "공간 예약 현황",
  "reservation.display.toast.title": "회사마다 공간 운영 정책이 다르므로, 예약 가능 시간은 Taap앱에서 확인해주세요.",
  "reservation.display.body.private": "비공개",
  "reservation.display.body.attendeeInfo.private": "주최자 비공개 참석자 비공개",
  "reservation.display.detail.private": "비공개",
  "reservation.display.setting.building": "건물",
  "reservation.display.setting.floor": "층",
  "reservation.display.setting.type": "공간유형",
  "reservation.display.setting.room": "회의실",
  "reservation.display.setting.desk": "좌석",
  "reservation.display.setting.amenity": "편의시설",
  "reservation.display.setting.all": "전체",
  "reservation.display.setting.title": "조회하실 조건을 선택해 주세요",

  // 웹 버전 업데이트 안내
  "update.available": "새 버전이 배포되었습니다. 새로고침하면 최신 화면으로 업데이트됩니다.",
  "update.reload": "새로고침",
  "update.collapse": "접기",
  "update.expand": "새 버전 안내 펼치기",
  "update.badge": "새 버전이 있습니다.",
};
